import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=f5256ee4&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"
import style0 from "./TabTitle.vue?vue&type=style&index=0&id=f5256ee4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5256ee4",
  null
  
)

export default component.exports